import React from 'react';
import './DonationItem';
import DonationItem from './DonationItem';
import '../styles/DonationInfo.css';

function DonationInfo() {
  return (
    <div className="orgs-container">
      <h1 className="donations__title">Make A Donation! Save A Life!</h1>
      <div className="orgs">
        {orgsList.map((org, index) => (
          <DonationItem
            key={`${org.name}-donation-item-${index}`}
            name={org.name}
            about={org.about}
            url={org.url}
            image={org.image}
          />
        ))}
      </div>
    </div>
  );
}

const orgsList = [
  {
    name: 'American Red Cross',
    about:
      'Red Cross volunteers and staff work to deliver vital services – from providing relief and support to those in crisis, to helping you be prepared to respond in emergencies.',
    url: 'https://www.redcross.org/donate/donation.html/',
    image: 'redcross.jpg'
  },
  {
    name: 'United Way Worldwide',
    about:
      'United Way is engaged in nearly 1,800 communities across more than 40 countries and territories worldwide.  We are focused on creating community-based and community-led solutions that strengthen the cornerstones for a good quality of life: education, financial stability and health.',
    url:
      'https://www.unitedway.org/get-involved/ways-to-give/donate?source=maindonatebutton&utm_source=homepage&utm_medium=web',
    image: 'unitedway.jpg'
  },
  {
    name: 'CDC Foundation',
    about:
      'The CDC Foundation, a nonprofit organization, helps serve ALL OF US, all of the many needs that arise during an emergency response that the federally-funded CDC cannot cover.',

    url: 'https://give4cdcf.org/',
    image: 'cdc.jpg'
  },
  {
    name: 'Direct Relief',
    about:
      'Direct Relief is coordinating with public health authorities, nonprofit organizations and businesses in the U.S. and globally to provide personal protective equipment, essential medical items, and emergency funding to health workers and organizations responding to coronavirus (COVID-19)',
    url: 'https://www.directrelief.org/emergency/coronavirus-outbreak/',
    image: 'directrelief.jpg'
  },
  {
    name: 'Project HOPE',
    about:
      'When disasters or health emergencies like the devastating coronavirus pandemic strike, Project HOPE is there to save lives. Our teams are at work around the world helping people overcome illness and providing health workers with the training and tools they need to stay safe and care for their communities.',
    url:
      'https://secure.projecthope.org/site/SPageNavigator/2020_Main_emergency_response_unr.html?autologin=true&mfc_pref=T&s_subsrc=oth&utm_source=fundraising&utm_medium=web&utm_campaign=ghef',
    image: 'projecthope.jpg'
  },
  {
    name: 'Global Giving',
    about:
      'GlobalGiving is the largest global crowdfunding community connecting nonprofits, donors, and companies in nearly every country. We help nonprofits from Afghanistan to Zimbabwe (and hundreds of places in between) access the tools, training, and support they need to be more effective and make our world a better place.',
    url: 'https://www.globalgiving.org/projects/coronavirus-relief-fund/',
    image: 'globalgiving.jpg'
  },
  {
    name: 'World Health Organization',
    about:
      'Working with 194 Member States, across six regions, and from more than 150 offices, WHO staff are united in a shared commitment to achieve better health for everyone, everywhere. Together we strive to combat diseases – communicable diseases like influenza and HIV, and noncommunicable diseases like cancer and heart disease.',
    url: 'https://covid19responsefund.org/en/',
    image: 'who.jpg'
  }
];

export default DonationInfo;
